import { createColumnHelper, ColumnDef } from '@tanstack/react-table';

export interface ColumnConfig {
  id: string;
  header: string | (() => JSX.Element);
  cell?: (props: any) => JSX.Element | string;
  enableSorting?: boolean;
  size?: number;
}

export const useColumnConfig = (defaultHeaders?: string[]) => {
  const columnHelper = createColumnHelper<any>();

  const generateColumns = (columns: ColumnConfig[]): ColumnDef<any>[] => {
    return columns.map(column => columnHelper.accessor(column.id, {
      header: column.header,
      cell: column.cell ?? ((props: any) => props.row.original[column.id]),
      enableSorting: column.enableSorting ?? true,
      size: (typeof column.header === 'string' && column.header === "#") ? 5 : column.size,
    }));
  };

  return { generateColumns };
};
